import { t } from '@lingui/core/macro';
import {
  TDateUnit,
  TIntroducerApplication,
} from 'lendingApi/applications.types';

const durationUnits = () => ({
  months: t`months`,
  days: t`days`,
  years: t`years`,
});

type DurationUnits = 'months' | 'days' | 'years';
export function getDurationUnit(unit: DurationUnits) {
  if (durationUnits()[unit]) {
    return durationUnits()[unit];
  }
  return '';
}

export function calculateMonthDifference(date1: Date, date2: Date) {
  const yearDiff = date2.getFullYear() - date1.getFullYear();
  const monthDiff = date2.getMonth() - date1.getMonth();

  const totalMonthDiff = yearDiff * 12 + monthDiff;

  return Math.max(totalMonthDiff, 1);
}

export function getDurationInMonths(
  duration?: { amount: number; unit: TDateUnit } | null,
) {
  if (!duration) {
    return null;
  }

  switch (duration.unit) {
    case 'days':
      // iwocaPay loans are only 90 days, which is 2.96 months
      return Math.round((duration.amount / 365) * 12);
    case 'months':
      return duration.amount;
    case 'years':
      return duration.amount * 12;
  }
}

export function useFormattedOfferDuration(
  duration:
    | TIntroducerApplication['formal_offer_sets'][number]['formal_offers'][number]['duration']
    | TIntroducerApplication['requested_products'][number]['duration'],
) {
  if (!duration) {
    return 'Not specified';
  }
  return `${getDurationInMonths(duration)} ${getDurationUnit('months')}`;
}
